import { Typography as MuiTypography, TypographyProps } from '@mui/material';

type TTypographyProps = TypographyProps & {
  lineClamp?: number;
};

export function Typography({ children, lineClamp, sx, ...other }: TTypographyProps) {
  return (
    <MuiTypography
      {...other}
      sx={{
        ...sx,
        ...(lineClamp && {
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: lineClamp,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          overflowWrap: 'break-word',
        }),
      }}
    >
      {children}
    </MuiTypography>
  );
}
